/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import { later } from '@ember/runloop';
import { getTablePrintCss } from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
} from '@linc-technologies/linced-common/utils/file-names';
import moment from 'moment';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';
import {
  byKeys,
  compact,
  mapBy,
} from '@linc-technologies/linced-common/utils/arrays';

export default class TabularController extends Controller {
  @service
  excel;

  title = 'Tabular Set of Class Lists';
  date = moment().format('YYYY-MM-DD');
  roomsPerTable = 5;

  @computed('model.homerooms.[]')
  get tables() {
    return this.getTableData(true);
  }

  @sort('model.homerooms', naturalSort('name'))
  sortedHomerooms;

  @action
  downloadFullXlsx() {
    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(this.getExportData(), {
      fileName: cleanFileName(fileName),
      sheetName: cleanExcelSheetName('All Classes'),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let title = `<h1>All Classes</h1>`;
    let tables = document.querySelectorAll('table');
    let content = getTablePrintCss(true) + title;

    tables.forEach((table, index) => {
      if (index !== 0) {
        content += `<div style="page-break-before: always"></div>`;
      }

      content += table.outerHTML;
    });

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getMaxClassSize(homerooms) {
    return homerooms.reduce((acc, homeroom) => {
      return Math.max(homeroom.currentLearners.length, acc);
    }, 0);
  }

  getExportData() {
    let data = [];

    // Column headers
    data.push(this.sortedHomerooms.map((homeroom) => homeroom.name));

    // Student numbers
    data.push(
      this.sortedHomerooms.map(
        (homeroom) => `${homeroom.currentLearners.length} students`,
      ),
    );

    return data.concat(this.getTableData(false));
  }

  getTableData(breakColumns) {
    let homerooms = this.sortedHomerooms;
    if (!breakColumns) {
      return this.rowsToColumns(homerooms);
    }

    let numTables = Math.ceil(homerooms.length / this.roomsPerTable);
    let tables = [];

    for (let tableIdx = 0; tableIdx < numTables; tableIdx++) {
      let chunk = homerooms.slice(
        tableIdx * this.roomsPerTable,
        (tableIdx + 1) * this.roomsPerTable,
      );

      tables.push(this.rowsToColumns(chunk));
    }

    return tables;
  }

  rowsToColumns(homerooms) {
    let numRows = this.getMaxClassSize(homerooms);
    let table = [];

    for (let rowIdx = 0; rowIdx < numRows; rowIdx++) {
      let row = [];

      homerooms.forEach((homeroom) => {
        let learners = compact(mapBy(homeroom.currentLearners, 'person')).sort(
          byKeys('lastName', 'firstName'),
        );

        if (learners.length > rowIdx) {
          let learner = learners[rowIdx];
          row.push(`${learner.lastName}, ${learner.firstName}`);
        } else {
          row.push('');
        }
      });

      table.push(row);
    }

    return table;
  }
}
